<div class="layout-container">
	<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
	<div class="spinner" *ngIf="loading">
		<mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
	</div>
	<ng-container *ngIf="!tokenID && !errorScreen">
		<div class="mdc-layout-grid__inner center gap-0">
			<div class="mdc-layout-grid__cell--span-12">
				<img class="paymentPageImg" [src]="'/assets/images/payment/payment-success-hourglass.svg' | s3Image" class="img-responsive" />
			</div>

			<div class="mdc-layout-grid__cell--span-12 paymentSuccessMessage mt-3">
				<h2 *ngIf="user['userType'] === '0'">{{ locale.translations['payment']['n620'] }}</h2>
				<h6 *ngIf="user['userType'] === '0'">
					{{ package === 'vip' ? locale.translations['payment']['payment-success']['n218'] : locale.translations['ads']['ad']['n658'] }}
				</h6>

				<h2 *ngIf="user['userType'] === '1'">{{ locale.translations['payment']['n620'] }}</h2>
				<h6 *ngIf="user['userType'] === '1'">
					{{ package === 'vip' ? locale.translations['payment']['payment-success']['n218'] : locale.translations['ads']['ad']['n658'] }}
				</h6>
			</div>

			<div class="mdc-layout-grid__cell--span-12" *ngIf="!embedded">
				<a class="success-btn fw-400" mat-flat-button color="primary" [routerLink]="['/ad/' + adID]">
					{{ locale.translations['place-ad']['place-ad-success']['n122'] }}
				</a>
			</div>
		</div>
	</ng-container>

	<ng-container *ngIf="tokenID && !errorScreen">
		<div class="mdc-layout-grid__inner center">
			<div class="mdc-layout-grid__cell--span-12">
				<img class="paymentPageImg" [src]="'/assets/images/payment/payment-success-hourglass.svg' | s3Image" class="img-responsive" />
			</div>

			<div class="mdc-layout-grid__cell--span-12 paymentSuccessMessage mt-3">
				<h2 *ngIf="user['userType'] === '0'" class="phone-text">{{ locale.translations['payment']['payment-success']['n469'] }}</h2>
				<h6 *ngIf="user['userType'] === '0'">{{ locale.translations['place-ad']['place-ad-success']['n470'] }}</h6>

				<h2 *ngIf="user['userType'] === '1'" class="phone-text">{{ locale.translations['payment']['payment-success']['n469'] }}</h2>
				<h6 *ngIf="user['userType'] === '1'">{{ locale.translations['place-ad']['place-ad-success']['n470'] }}</h6>
			</div>

			<div class="mdc-layout-grid__cell--span-12" *ngIf="!embedded">
				<a class="success-btn fw-400" mat-flat-button color="primary" [routerLink]="['/ad/' + adID]">
					{{ locale.translations['place-ad']['place-ad-success']['n122'] }}
				</a>
			</div>
		</div>
	</ng-container>
	<ng-container *ngIf="errorScreen">
		<div class="mdc-layout-grid__inner center">
			<div class="mdc-layout-grid__cell--span-12">
				<mat-icon class="large">cancel</mat-icon>
			</div>

			<div class="mdc-layout-grid__cell--span-12">
				<h2>{{ locale.translations['payment']['n338'] }}</h2>
				<p>{{ locale.translations['payment']['n339'] }}</p>
			</div>
		</div>
	</ng-container>
</div>
